import { Modal } from '@skezi/ui';
import { Dispatch, SetStateAction } from 'react';
import { BasicButton } from '../../../../src/components/common/Button';

type YouHaveKidsModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const YouHaveKidsModal = ({ open, setOpen }: YouHaveKidsModalProps) => {
  return (
    <Modal
      title='Impossible de supprimer votre compte'
      show={open}
      onClose={() => setOpen(false)}
      titleSize='text-xl font-semibold text-secondary-default'
      contentClassName='max-w-xl! min-h-ull sm:min-h-[unset] px-4 rounded-2xl!'
    >
      <div className='flex w-full flex-col items-center justify-start gap-y-6'>
        <p className='text-center'>
          Vous avez inscrit au moins un enfant dans au moins l&apos;un des projets auxquels vous participez. Pour supprimer votre compte,
          veuillez contacter le support.
        </p>
        <BasicButton
          onClick={() => setOpen(false)}
          template='orangeOutline'
          fullRounded
          label='Fermer'
          className='mt-0! cursor-pointer text-sm text-black!'
        />
      </div>
    </Modal>
  );
};

export default YouHaveKidsModal;
